export default __webpack_public_path__ + "static/carousel1-c0a7c406afe72aee316b27fbc795f2e3.png";